import React from 'react';
import {curry} from 'ramda';
import {BreadcrumbsProps, Crumbs} from './BreadcrumbsTypes';
import BreadcrumbPreviousLink from './BreadcrumbPreviousLink';
import BreadcrumbCurrentLocation from './BreadcrumbCurrentLocation';

import './Breadcrumbs.scss';

export const mapBreadcrumbPart = curry(
    (crumbs: Crumbs[], {name, route}: Crumbs, key: number) => {
        return key + 1 === crumbs.length ? (
            <BreadcrumbCurrentLocation
                name={name}
                key={key}
            />
        ) : (
            <BreadcrumbPreviousLink
                key={key}
                name={name}
                route={route}
            />
        );
    },
);

export default function Breadcrumbs(props: BreadcrumbsProps) {
    const {crumbs} = props;
    
    if (!crumbs.length) return null;
    
    return (
        <div className="breadcrumbs">
            {crumbs.map(mapBreadcrumbPart(crumbs))}
        </div>
    );
}
